import { render, staticRenderFns } from "./ConsultDetails.vue?vue&type=template&id=70a8696e&scoped=true"
import script from "./ConsultDetails.vue?vue&type=script&lang=js"
export * from "./ConsultDetails.vue?vue&type=script&lang=js"
import style0 from "./ConsultDetails.vue?vue&type=style&index=0&id=70a8696e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a8696e",
  null
  
)

export default component.exports